import { className, scrollToSection } from "../../../Utils.js";
import Slider from '../../Slider/Slider';
import { useTranslations } from "../../../lang/TranslationHooks";
import { useSelector } from "react-redux";
import { sliderData } from "../PregnancyConstants.js";
import { isMobile } from 'react-device-detect';
import modulePregnancy from '../../../assets/modulePregnancy-fixed.mp4'
import parentsModuleFixed from '../../../assets/moduleParents-fixed.mp4'
import modulePregnancyEs from '../../../assets/es/modulePregnancyEs.mp4'

import parentingFrame from '../../../assets/parenthood-frame.png';
import pregnancyFrame from '../../../assets/pregnancy-frame.png'
import cloudsWwhite from '../assets/clouds-white.png'
import './FutureMother.css'

const FutureMother = () => {
    const { language } = useSelector((state) => state.home)
    let { staticTranslate } = useTranslations();

    const ios = 'https://apps.apple.com/us/app/feia-%D0%B1%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%BD%D0%BE%D1%81%D1%82/id1299624022?ls=1'
    const android = "https://play.google.com/store/apps/details?id=bg.feia.Pregnancy"

    return (
        <div className={className('container-section') + ' ' + className(`container-section-${language}`)} id='section02'>
            <div className={className('container-section-wrapper')}>
                <div className={className('container-left')}>
                    <Slider
                        sliderData={sliderData[language]}
                        photoFrame={pregnancyFrame}
                        videoUrl={language === 'bg' ? modulePregnancy : modulePregnancyEs}
                    />
                </div>
                <div className={className('container-right')}>
                    <h2 className={className('container-right-title')}>
                        {staticTranslate('t_pregnancy_module', true)}
                        <span>{staticTranslate('t_module_pregnancy', true)}</span>
                    </h2>
                    <p className={className('container-subTitle')}>{staticTranslate('t_pregnancy_second_section_title', true)} </p>
                    < div
                        className={className('container-right-content')}
                        dangerouslySetInnerHTML={{
                            __html: staticTranslate('t_pregnancy_second_section_content')
                        }}
                    />

                    <div
                        className={className('install-now-button')}
                        onClick={() => isMobile
                            ? window.location.href = window.navigator.userAgent.indexOf('Mac OS') !== -1
                                ? ios
                                : android
                            : scrollToSection('add-price-container')}
                    >
                        {staticTranslate('t_pregnancy_second_section_install_now', true)}
                    </div>
                </div>
            </div>
            {language === 'bg' &&
                <div className={className('container-section-wrapper')}>
                    <div className={className('container-right')}>
                        <h2 className={className('container-right-title')}>
                            {staticTranslate('t_pregnancy_module', true)}
                            <span>{staticTranslate('t_module_parents', true)}</span>
                        </h2>
                        <p className={className('container-subTitle')}>{staticTranslate('t_pregnancy_module_parents_section_subtitle', true)} </p>
                        <div
                            className={className('container-right-content')}
                            dangerouslySetInnerHTML={{
                                __html: staticTranslate('t_parents_section_content')
                            }}
                        />
                        <div
                            className={className('install-now-button')}
                            onClick={() => isMobile
                                ? window.location.href = window.navigator.userAgent.indexOf('Mac OS') !== -1
                                    ? ios
                                    : android
                                : scrollToSection('add-price-container')}
                        >
                            {staticTranslate('t_pregnancy_second_section_install_now', true)}
                        </div>
                    </div>
                    <div className={className('container-left')}>
                        <Slider sliderData={sliderData[language]} photoFrame={parentingFrame}
                            videoUrl={parentsModuleFixed}
                        />
                    </div>

                </div>
            }
            {language !== 'bg' &&
                <div>
                    <img
                        src={cloudsWwhite}
                        className={className('future-mother-clouds-white')}
                        alt="cloudsWwhite"
                    />
                </div>
            }
        </div>
    )
}

export default FutureMother

